// API Configuration
// No ?version pin — the backend then runs the currently PUBLISHED version.
export const EXECUTE_URL = "/m4ai/api/v1/agent-systems/doorcrashanalysis/execute";

// Queries
export const TESTCASE_QUERY = `Determine all variants that meet these conditions:
- force_039 > 20 kN
- force_059 > 35 kN
- force_079 > 45 kN
- force_099 > 65 kN
- maximum displacement max_disp < 0.8 mm

Create a list of all variants and their properties that satisfy these criteria.

Answer format:
Variant | force_039 | force_059 | force_079 | force_099 | max_disp`;
export const REVIEWS_QUERY = `Determine all variants that meet these conditions:
- force_039 > 20 kN
- force_059 > 33 kN
- force_079 > 42 kN
- force_099 > 63 kN
- maximum displacement max_disp < 0.8 mm

Create a list of all variants and their properties that satisfy these criteria.

Answer format:
Variant | force_039 | force_059 | force_079 | force_099 | max_disp  `;
// UI Constants
export const TEXTAREA_CONFIG = {
  MAX_LINES: 8,
  LINE_HEIGHT: 24,
  get MAX_HEIGHT() { return this.MAX_LINES * this.LINE_HEIGHT; }, // 192px
  MIN_HEIGHT: '3rem'
};

// Animation Timings
export const ANIMATION_DURATIONS = {
  ROBOT_PRINT_DELAY: 25, // ms between lines when printing robot code
  STATE_RESET_DELAY: 50   // ms delay for state updates to complete
};

// Panel IDs
export const PANEL_IDS = {
  ANALYSIS: 'analysis',
  TESTCASES: 'testcases',
  ROBOT: 'robot'
};